<template>
  <div v-if="travelbagsOnly && showLoyaltyUsps">
    <div class="my-account__text">
      <p
        v-text="$t('Create your free account now and save for discounts and benefits')"
      />
    </div>

    <div
      class="my-account__usps"
    >
      <ul class="usps__list usps--vertical">
        <li class="usps__item">
          <IconStamp
            filled
            class="usps__icon usps__icon--stamp"
          />
          <span class="usps__label">{{ $t('Get a stamp for every 25 euros') }}</span>
        </li>
        <li class="usps__item">
          <IconGift
            class="usps__icon usps__icon--gift"
          />
          <span class="usps__label">{{ $t('Save for discounts and free gifts') }}</span>
        </li>
        <li class="usps__item">
          <IconConfetti
            class="usps__icon usps__icon--confetti"
          />
          <span class="usps__label">{{ $t('Extra stamps through promotions and surprises') }}</span>
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <div
      class="my-account__text"
    >
      <p v-text="$t('Creating an account has many benefits: check out faster, keep more than one address, track orders and more.')" />
    </div>
  </div>
</template>

<script setup lang="ts">
const { public: config } = useRuntimeConfig()

const showLoyaltyUsps = computed(
  () => config.storeHeader === 'tra_nl_nl',
)

const travelbagsOnly = computed(
  () => config.storeHeader.startsWith('tra'),
)
</script>

<style>
@import url("~layers/app/components/Account/Usps.css");
</style>
